import { useState, useEffect, useMemo } from 'react';

import api from '../../apis';
import moment from 'moment';


import ReactTable from '../general/form-control/react-table';


import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

const TradeOrderLogsTbl = ({
    orderNo
}:any) => {
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        requestTradeOrderLogs(orderNo);
    }, []);
 

    const requestTradeOrderLogs = async (orderNo:string) =>{
        if(!orderNo)return;
  
        setLoading(true)
        let result = await api.getTradeHistoryLogs(orderNo);

        if(result.logs){
            setTableData(result.logs)
        }
        setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }

    const tblColumns = useMemo(
        () => [
            {
                Header: 'Created Time',
                accessor: 'datetime',
                Cell: (data: any) => {
                    if(!data.value) return;
                    return moment(data.value).format('yyyy-MM-DD HH:mm:ss');
                }
            },
            {
                Header: 'Message',
                accessor: 'message'
            },
       
        ],
        []
    );



    return (
        <>
            <ReactTable
                headerStyle={{
                    background: 'rgba(210, 209, 209, 1)',
                    color:"black"
                }}
                columns={tblColumns}
                data={tableData}
                pageSize={999}
                loading={loading}
                size='small'
                // currentPage={1}
                // totalRecords={8}
                // hasPagination
            />
        </>
    );
};

export default TradeOrderLogsTbl;
